<footer class="footer dx-toolbar">
  <div class="copyright">
    <span *ngIf="version != ''" style="margin-right:15px;float:left;">Version {{version}}</span>{{currentYear}} © Fitterandfaster.Com, Inc.
  </div>
</footer>